import type { FC } from "react";
import React from "react";

import { PageContainer } from "@react/web/app";

import { GithubConnectionsView } from "../features/github/index.ts";

export const GithubConnections: FC = () => (
  <PageContainer>
    <GithubConnectionsView />
  </PageContainer>
);
